import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/sharedModule/sharedModule.module';
import { XLoaderComponent } from './x-loader.component';

@NgModule({
  imports: [SharedModule],
  declarations: [XLoaderComponent],
  exports: [XLoaderComponent],
})
export class XLoaderModule {}
